export class LiveChatError extends Error {
  public context: Record<string, unknown>;

  constructor(message: string, context: Record<string, unknown> = {}) {
    super(message ?? 'Unknown LiveChatError');

    this.name = 'LiveChatError';
    this.context = context;

    Object.setPrototypeOf(this, LiveChatError.prototype);
  }
}

export async function isUtagLoaded(): Promise<boolean> {
  return !!window.utag;
}
